import React from 'react'
import '../App.css';
import { Transition } from 'react-transition-group';
import { IconButton, Popover, Typography, Button} from '@material-ui/core';
import { FiHelpCircle } from "react-icons/fi";
import { useStyles } from '../Components/useStyles';

export default function ChooseApplicationPage({setAppliedProgram, showCATPage}) {
    const transitionStyles = {
        entering: { opacity: 1 },
        entered:  { opacity: 1 }, 
        exiting:  { opacity: 0 },
        exited:  { opacity: 0 },
    };
    const duration = 700;
    const defaultStyle = {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
    }
    const [anchorEl, setAnchorEl] = React.useState(null);
    function openHelp(event) {
        setAnchorEl(event.currentTarget);
    }
    function closeHelp() {
        setAnchorEl(null);
    }
    const classes = useStyles();
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <Transition in={showCATPage} timeout={duration} appear>
                {state => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                    <h1 className='Title2-settings'>Which program would you like to apply for?</h1> 
                    <p className='addSpaceTop'> </p>
                    <p className='details1'>
                        <b>Early French Immersion (EFI)</b><br/> Students entering Kindergarten or Grade 1 may apply <br/><br/>
                        <b>Montessori</b> <br/>Students entering Kindergarten and Grades 1-4 may apply <br/><br/>
                        <b>Late French Immersion (LFI)</b> <br/>Students entering Grade 6 may apply
                    </p>
                    <p className='addSpaceBottom'> </p>
                    <Button variant="outlined"  color="primary" className={classes.button} onClick={event=>setAppliedProgram('EFI')}>Early French Immersion</Button>
                    <Button variant="outlined"  color="primary" className={classes.button} onClick={event=>setAppliedProgram('LFI')}>Late French Immersion</Button>           
                    <Button variant="outlined"  color="primary" className={classes.button} onClick={event=>setAppliedProgram('Montessori')}>Montessori</Button>
                </div>)}
            </Transition> 
        </>
    );
}